import path from 'path'
import dotenv from 'dotenv'
import appConfig from '@app/config/packages/iprofesional.yaml'
import twigConfig from '@core/../config/packages/twig.yaml'

const dirname = path.resolve(__dirname, './../../.env');

const dotenvConfig = dotenv.config({
  path: dirname,
  override: true
});

const findValue = (parameter) => {
  // Tomamos el parámetro del .env
  if (parameter.includes('env')) {
    const regex = /%env\(([^)]+)\)%/;
    const envAttr = parameter.match(regex);
    parameter = dotenvConfig.parsed[envAttr[1]] ?? false
  // Tomamos el parámetro de la configuración de la aplicacións
  } else if (parameter.includes('%')) {
    parameter = appConfig.iprofesional_core[parameter.replaceAll('%', '')]
  }

  return parameter
}

const parseConfig = (config) => {
  return Object.fromEntries(
    Object.entries(config).map(([attr, value]) => {
      if ('object' === typeof value) {
        value = parseConfig(value)
      } else if ('string' === typeof value) {
        value = findValue(value)
      }

      return [attr, value]
    })
  )
}

const settings = 'undefined' !== typeof window ? window.__SETTINGS__ : parseConfig(twigConfig.twig.globals.settings);

export default settings
